import script from "./GatewayManager.vue?vue&type=script&setup=true&lang=js"
export * from "./GatewayManager.vue?vue&type=script&setup=true&lang=js"

import "./GatewayManager.vue?vue&type=style&index=0&id=93352ff2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93352ff2"]])

export default __exports__